import clsx from 'clsx';
import type { ButtonHTMLAttributes } from 'react';

import { Icon } from '../icon';
import { Loader } from '../loader';

import styles from './ai-button.module.scss';

export const AiButton = (props: AiButtonProps) => {
  const { size = 'default', loading, disabled, onClick, icon } = props;

  return (
    <div
      className={clsx(styles.aiBtnHolder, styles[`s-${size}`], {
        [styles.loading]: loading,
      })}
    >
      <Loader size={30} />
      <button onClick={onClick} data-testid="primary-btn" className={styles.aiBtn} disabled={disabled || loading}>
        <Icon size={size === 'medium' ? 22 : 24} type={icon} />
      </button>
    </div>
  );
};

export interface AiButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: string;
  loading: boolean;
  size?: 'default' | 'medium';
}
